var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNzt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 24,
    viewBox: "0 0 57 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2001_2458",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5376 0H12C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H44.5376C51.165 24 56.5376 18.6274 56.5376 12C56.5376 5.37258 51.165 0 44.5376 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2001_2458)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2001_2458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4868 0H12C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H44.4868C51.1142 24 56.4868 18.6274 56.4868 12C56.4868 5.37258 51.1142 0 44.4868 0Z",
    fill: "#0064FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.81763 12.0001C1.81763 6.30922 6.43104 1.6958 12.122 1.6958H32.5227V22.3045H12.122C6.43104 22.3045 1.81763 17.6911 1.81763 12.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1007 14.0429C42.5315 14.5687 41.759 14.8693 40.9457 14.8693C40.1326 14.8693 39.36 14.5687 38.7908 14.0053C37.571 12.8784 37.571 11.0753 38.7908 9.94821L43.5887 5.47803L48.3865 9.94821C49.6062 11.0753 49.6062 12.8784 48.3865 14.0053L48.3458 14.0429C47.1668 15.1322 45.2153 15.1323 44.0361 14.0054C44.15 15.7611 45.4353 17.1912 47.1039 17.4936V17.9998H40.0729V17.4936C41.7544 17.1888 43.0466 15.7391 43.1432 13.9648L43.1007 14.0429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3671 16.0504V9.80092H22.0525V7.94922H28.7649V9.80092H26.4503V16.0504H24.3671Z",
    fill: "#0064FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3953 16.0504V14.488L19.0987 9.74305H15.511V7.94922H21.7605V9.51159L18.0571 14.2566H21.8183V16.0504H15.3953Z",
    fill: "#0064FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58887 16.0504V7.94922H10.2507L12.9125 12.9835V7.94922H14.9957V16.0504H12.3338L9.67203 11.0161V16.0504H7.58887Z",
    fill: "#0064FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2001_2458",
    x: -7.8,
    y: -6.6,
    width: 72.0868,
    height: 39.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.952941 0 0 0 0 0.635294 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2001_2458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2001_2458",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNzt);
export default __webpack_public_path__ + "static/media/LogoNZT.c8ee43479e6fb3f93142b28d3185201a.svg";
export { ForwardRef as ReactComponent };